import { apiClient } from '@/shared/api/client';
import type {
  Verification,
  CreateVerificationRequest,
  ListVerificationsParams,
} from '../types/verification.types';
import type { ApiResponse } from '@/shared/types/api.types';

export const verificationService = {
  async listVerifications(params: ListVerificationsParams): Promise<Verification[]> {
    const endpoint = `/candidates/${params.candidateId}/experiences/${params.experienceId}/verifications`;
    const response = await apiClient<ApiResponse<Verification[]>>(endpoint, { method: 'GET' });
    return response.data;
  },

  async getVerificationById(
    candidateId: string,
    experienceId: string,
    verificationId: string
  ): Promise<Verification> {
    const response = await apiClient<ApiResponse<Verification>>(
      `/candidates/${candidateId}/experiences/${experienceId}/verifications/${verificationId}`,
      { method: 'GET' }
    );
    return response.data;
  },

  async createVerification(
    candidateId: string,
    experienceId: string,
    request: CreateVerificationRequest
  ): Promise<Verification> {
    const response = await apiClient<ApiResponse<Verification>>(
      `/candidates/${candidateId}/experiences/${experienceId}/verifications`,
      { method: 'POST', body: request }
    );
    return response.data;
  },

  async deleteVerification(
    candidateId: string,
    experienceId: string,
    verificationId: string
  ): Promise<void> {
    await apiClient<ApiResponse<void>>(
      `/candidates/${candidateId}/experiences/${experienceId}/verifications/${verificationId}`,
      { method: 'DELETE' }
    );
  },

  async refreshShareLink(
    candidateId: string,
    experienceId: string,
    verificationId: string
  ): Promise<{ shareId: string; refreshed: boolean }> {
    const response = await apiClient<ApiResponse<{ shareId: string; refreshed: boolean }>>(
      `/candidates/${candidateId}/experiences/${experienceId}/verifications/${verificationId}/refresh-share-link`,
      { method: 'POST' }
    );
    return response.data;
  },
};
